"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ArtistActivityBadge } from "@/components/waves/drops/ArtistActivityBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
interface MemeDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
export default function MemeDropArtistInfo(t0) {
  const $ = _c(42);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  const hasActivityBadge = hasSubmissions || isWinner;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.level) {
    t2 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author.level;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/${drop.author?.handle}`;
  let t4;
  if ($[4] !== drop.author.handle || $[5] !== drop.author.id) {
    t4 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span></UserProfileTooltipWrapper> : <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span>;
    $[4] = drop.author.handle;
    $[5] = drop.author.id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Link href={t3} onClick={_temp} className="tw-no-underline">{t4}</Link>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop.id || $[11] !== handleBadgeClick || $[12] !== hasActivityBadge || $[13] !== submissionCount || $[14] !== winnerCount) {
    t6 = hasActivityBadge && <ArtistActivityBadge submissionCount={submissionCount} winCount={winnerCount} onBadgeClick={handleBadgeClick} tooltipId={`meme-activity-badge-${drop.id}`} />;
    $[10] = drop.id;
    $[11] = handleBadgeClick;
    $[12] = hasActivityBadge;
    $[13] = submissionCount;
    $[14] = winnerCount;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== drop.created_at) {
    t8 = <WaveDropTime timestamp={drop.created_at} />;
    $[17] = drop.created_at;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = drop.winning_context?.decision_time ?? null;
  let t10;
  if ($[19] !== drop.rank || $[20] !== t9) {
    t10 = <div className="tw-ml-2"><WinnerDropBadge rank={drop.rank} decisionTime={t9} /></div>;
    $[19] = drop.rank;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t2 || $[24] !== t5 || $[25] !== t6 || $[26] !== t8) {
    t11 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t5}{t6}{t7}{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t2;
    $[24] = t5;
    $[25] = t6;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== drop.wave) {
    t12 = drop.wave && <Link onClick={_temp2} href={`/waves?wave=${drop.wave.id}`} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[28] = drop.wave;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t11}{t12}</div>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== drop.author || $[34] !== handleModalClose || $[35] !== isModalOpen || $[36] !== modalInitialTab) {
    t14 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[33] = drop.author;
    $[34] = handleModalClose;
    $[35] = isModalOpen;
    $[36] = modalInitialTab;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t1 || $[39] !== t13 || $[40] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-3">{t1}{t13}{t14}</div>;
    $[38] = t1;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}